import React, {useEffect} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../store/store';

const VerifiedGuard = observer(({setPreloader, children}) => {
  const store = useStore();
    console.log(store.user.is_verified)
  // как только стало понятно, что юзер есть
  useEffect(() => {
    if (store.user && store.user.is_verified !== true) {
      setPreloader(false);
    }
  }, [store.user]);

  // пока user грузится — ничего не ломаем
  if (!store.user) {
    return null;
  }
  
  // не верифицирован → заглушка
  if (store.user.is_verified !== true) {
    return (
      <div className="card">
        <div className="card-body text-center py-15">
          <h2>Требуется верификация</h2>
          <p>Пройдите верификацию, чтобы получить доступ</p>
        </div>
      </div>
    );
  }

  return children;
});

export default VerifiedGuard;
